import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-multi-stat',
  templateUrl: './form-multi-stat.component.html',
  styleUrls: ['./form-multi-stat.component.scss']
})
export class FormMultiStatComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
